"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PUT = exports.POST = exports.PATCH = exports.GET = exports.DELETE = void 0;
var DELETE = 'DELETE';
exports.DELETE = DELETE;
var GET = 'GET';
exports.GET = GET;
var PATCH = 'PATCH';
exports.PATCH = PATCH;
var POST = 'POST';
exports.POST = POST;
var PUT = 'PUT';
exports.PUT = PUT;